import React, { useState } from 'react';
import UserService from '../../components/service/UserService'; // Adjust import path
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Button, TextField } from '@mui/material';

function SignUp() {
    const navigate = useNavigate();

    // State for form data, including user_type and role
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        city: '',
        username: '',
        userType: 1, // Default userType
        role: '', // Role is now part of form data
    });

    const [error, setError] = useState(null); // Track registration errors
    const [isLoading, setIsLoading] = useState(false); // Loading state for submission

    // Handle input change and update state
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    // Handle form submission for registration
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Ensure userType is an integer
            const userData = {
                ...formData,
                userType: parseInt(formData.userType, 10),
            };

            // Call the register method from UserService
            await UserService.register(userData);

            // Clear form fields after successful registration
            setFormData({
                name: '',
                email: '',
                password: '',
                city: '',
                username: '',
                userType: 1, // Reset to default value
                role: '', // Reset role field
            });

            alert('User registered successfully');
            navigate('/login'); // Redirect to login after registration
        } catch (error) {
            console.error('Error registering user:', error.response ? error.response.data : error);
            setError('Failed to register user. Please try again.');
        } finally {
            setIsLoading(false); // Stop loading indicator
        }
    };

    return (
        <div className="auth-container" style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
            <h2>Sign Up</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>} {/* Display error message */}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <TextField
                        label="Name"
                        variant="outlined"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        fullWidth
                        sx={{ marginBottom: '16px' }}
                    />
                </div>
                <div className="form-group">
                    <TextField
                        label="Email"
                        variant="outlined"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        fullWidth
                        sx={{ marginBottom: '16px' }}
                    />
                </div>
                <div className="form-group">
                    <TextField
                        label="Password"
                        type="password"
                        variant="outlined"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        required
                        fullWidth
                        sx={{ marginBottom: '16px' }}
                    />
                </div>
                <div className="form-group">
                    <TextField
                        label="City"
                        variant="outlined"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        required
                        fullWidth
                        sx={{ marginBottom: '16px' }}
                    />
                </div>
                <div className="form-group">
                    <TextField
                        label="Username"
                        variant="outlined"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                        required
                        fullWidth
                        sx={{ marginBottom: '16px' }}
                    />
                </div>
                <div className="form-group">
                    <TextField
                        label="User Type"
                        variant="outlined"
                        name="userType"
                        value={formData.userType}
                        onChange={handleInputChange}
                        type="number"
                        required
                        fullWidth
                        sx={{ marginBottom: '16px' }}
                    />
                </div>
                <div className="form-group">
                    <TextField
                        label="Role"
                        variant="outlined"
                        name="role"
                        value={formData.role}
                        onChange={handleInputChange}
                        required
                        fullWidth
                        sx={{ marginBottom: '16px' }}
                    />
                </div>
                <Button
                    type="submit"
                    variant="contained"
                    sx={{ backgroundColor: '#0D5C75', color: 'white', width: '100%', marginTop: '20px' }}
                    disabled={isLoading} // Disable button while loading
                >
                    {isLoading ? 'Registering...' : 'Register'}
                </Button>
            </form>

            <Grid container sx={{ marginTop: '10%', justifyContent: 'center' }}>
                <Typography sx={{ fontFamily: 'Rubik' }}>
                    Already a user?
                </Typography>
                <a 
                    href="#" 
                    onClick={() => navigate('/login')} 
                    style={{ color: '#0D5C75', marginLeft: '4px', fontFamily: 'Rubik', fontWeight: 'bold', textDecoration: 'underline' }}>
                    Click here
                </a>
            </Grid>
        </div>
    );
}

export default SignUp;
